<template>
  <el-dialog custom-class="lesson-expType-dialog" center width="600px" title="开始实验" :visible.sync="showDialog">
    <el-row type="flex">
      <el-col v-if="[1,2].includes(expMode)">
        <div @click="selectType('local')">
          <img src="~@/assets/imgs/icon/experiment_local.png" alt="">
          <p><span>本地实验</span></p>
        </div>
        <p v-if="fileUrl" class="fileUpload"><el-link :href="fileUrl" target="_blank"> 请确定是否安装软件资源包,若未安装请点击此处下载安装 <i class="el-icon-s-promotion"></i></el-link></p>
      </el-col>
      <el-col v-if="[0,2].includes(expMode)">
        <div @click="selectType('remote')">
          <img src="~@/assets/imgs/icon/experiment_long_range.png" alt="">
          <p><span>远程实验</span></p>
        </div>
        <p class="tips">
          <el-button v-if="openReservation" type="success" size="small" @click="startReserva">
            立即预约
          </el-button>
        </p>
      </el-col>
    </el-row>

    <el-dialog width="70%" title="预约详情" :visible.sync="innerVisible" append-to-body>
      <appoint
          :event="event"
          :data="data"
          :day="day"
          @add="addEvent"
          @eventClick="handEventClick"
          @drop="handDrop"
      ></appoint>
    </el-dialog>
  </el-dialog>
</template>

<script>
import appoint from './appoint'
import {getAllExpReserva} from '@/api/io/lab-exp-reserva-config';
import {getAddReserva, getDelReserva, getPutReserva, getStudyReservaQuery} from '@/api/io/lab-exp-reserva-log';
import {getDetail} from '@/api/lab/lesson'
import {getExpSoftInfoByUid} from '@/api/lab/experiment'
import {mapGetters} from 'vuex'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    labExpUid: {
      type: String,
      required: true,
      default: "",
    },
    lessonName: {
      type: String,
      required: true,
      default: "",
    },
    expUid: {
      type: String,
      required: true,
      default: "",
    },
    expMode: {
      type: Number,
      default: 2,
    },
    openReservation: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      page: {
        page: 1,
        limit: 100,
        total: 0
      },
      fileUrl: '',
      showDialog: false,
      innerVisible: false,
      day: 7,
      limitDycle: 0,
      limitDay: 0,
      lessonInfo: {},
      event: [],
      data: []
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  watch: {
    visible(val) {
      if (val === this.showDialog) {
        return
      }
      this.getExpSoftInfoByUid(this.labExpUid)
      this.showDialog = val
    },
    showDialog(val) {
      if (val === this.visible) {
        return
      }

      this.$emit("update:visible", val)
    }
  },
  components: {
    appoint
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getAllExpReservaList()
      this.getLessonDetail()
    },
    getExpSoftInfoByUid(labExpUid){
      getExpSoftInfoByUid(labExpUid).then(res=>{
        const { fileUrl = '' } = res[0]
        this.fileUrl = fileUrl
      })
    },
    getLessonDetail() {
      const {uid} = this.$route.params
      getDetail(uid).then(res => {
        this.lessonInfo = res
      })
    },
    startReserva() { //打开日历弹窗,并调用数据回显查询预约
      this.innerVisible = true
      this.getStudyReservaQueryList()
    },
    getAllExpReservaList() { // 查询日历基本参数
      getAllExpReserva().then(res => {
        let {schedule, reserveDays, reservationTimes} = res[0]
        // reservationTimes 周期内可预约次数 reserveTimesPerDay每天可以预约次数
        schedule = schedule ? JSON.parse(schedule) || [] : []
        this.data = schedule
        this.day = reserveDays
        this.limitDycle = reservationTimes
      })
    },
    async getStudyReservaQueryList() { // 查询学生的预约记录
      let params = {
        labExpUid: this.labExpUid,
        userId: this.userInfo.id
      }
      const {page, limit} = this.page
      await getStudyReservaQuery(page, limit, params).then(res => {
        const {list} = res
        this.event = JSON.parse(JSON.stringify(list).replace(/reservationTime/g, 'start'))
      })
    },
    formatTime(t) { //格式化时间
      let a = new Date(t).toJSON()
      let b = new Date(+new Date(a) + 8 * 3600 * 1000)
      let c = b.toISOString()
      return c.replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
    },
    selectType(type) {
      this.$emit("handleStartExp", {
        type
      })
    },
    setState(state) {
      this.showDialog = state
    },
    async addReserva(info) { //添加预约记录
      let data = {
        labExpUid: this.labExpUid,
        lessonName: this.lessonName,
        reservationTime: this.formatTime(info.startStr),
        userId: this.userInfo.id,
        username: this.userInfo.username,
        labLessonName: this.lessonInfo.lessonName,
        labLessonUid: this.lessonInfo.uid,
        expUid: this.expUid,
        nickname: this.userInfo.nickname
      }
      await getAddReserva(data).then(() => {
        this.$message({
          type: 'success',
          message: '预约成功!'
        });
      }).catch(() => {
      });
      await this.getStudyReservaQueryList()
    },
    async delReserva(id) { //删除记录
      await getDelReserva(id).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      })
      await this.getStudyReservaQueryList()
    },
    addEvent(info) { //添加预约记录
      this.$confirm('是否选择该时间为预约时间?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.addReserva(info)
      }).catch(() => {
      });
    },
    handEventClick(val) { //点击当前事件执行删除
      this.$confirm('是否取消该预约?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let nTime = new Date().getTime()
        let eTime = (val.event.start).getTime()
        if (nTime < eTime) {
          this.delReserva(val.event.id)
        } else {
          this.$message({
            type: 'error',
            message: '实验已经开始,操作失败!'
          });
        }
      })
    },
    handDrop(val = {oldEvent: {}}) {
      let oTime = (val.oldEvent.start).getTime()
      let nTime = new Date().getTime()
      let eTime = (val.event.start).getTime()
      if (nTime < eTime) {
        if (oTime > nTime) {
          let data = {
            reservationTime: this.formatTime(val.event.start),
            id: val.event.id,
            userId: this.userInfo.id
          }
          getPutReserva(data).then(() => {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.getStudyReservaQueryList()
          }).catch(() => {
            val.revert()
          })
        } else {
          this.$message({
            type: 'error',
            message: '预约时间已过,禁止预约'
          });
          val.revert()
        }
      } else {
        this.$message({
          type: 'error',
          message: '预约时间已过,禁止预约'
        });
        val.revert()
      }
    }
  }
}
</script>

<style lang="scss">
.lesson-expType-dialog {
  &.el-dialog--center {
    .el-dialog__header {
      font-size: 24px;
      line-height: 3em;
      padding: 0;
      border-bottom: 1px solid #dcdcdc;
      color: #333;

      .el-dialog__title {
        margin-top: 0;
        font-size: inherit;
        line-height: inherit;
        color: inherit;
      }
    }

    .el-dialog__body {
      padding: 24px;
      text-align: inherit;

      .el-col {
        font-size: 16px;
        color: #333;
        cursor: pointer;

        p {
          span:hover {
            border-bottom: 1px solid #000;
          }
        }

        .fileUpload{
          color: #666;
          font-size: 14px;
          margin-top: 12px;
        }
        .tips {
          width: calc(100% - 136px);
          font-size: 14px;
          text-align: center;
          margin: 24px auto 0;
          color: red;
        }
      }

      .el-col:nth-child(2n) {
        border-left: 1px solid #dcdcdc;
      }

      .border-no {
        .el-col:nth-child(2n + 1) {
          border-right: none;
        }
      }
    }
  }
}
</style>
